<template>
  <v-card style="overflow: hidden">
    <v-row no-gutters align="stretch">
      <v-col cols="2" class="primary text-center py-2 d-flex flex-column justify-center">
        <div class="white--text" v-text="$t('trainingsession.fields.multiproject.title')" />
        <v-simple-checkbox
          v-model="internalValue.active"
          class="mt-1"
          dark
          @input="change"
        />
      </v-col>
      <v-col>
        <v-row no-gutters class="px-5">
          <v-col class="px-5">
            <v-autocomplete
              v-model="internalValue.versionId"
              :items="multiProjectVersionList"
              :label="$t('trainingsession.fields.multiproject.versionId')"
              :rules="internalValue.active ? $options.rules.versionId : []"
              :disabled="!internalValue.active"
              item-text="name"
              item-value="id"
              @input="change"
            />
          </v-col>
          <v-col class="px-5">
            <v-tooltip
              :value="internalValue.active && !internalValue.nbProject"
              top
              nudge-bottom="20"
            >
              <template v-slot:activator="{ on, attrs }">
                <ag-number-select
                  v-model="internalValue.nbProject"
                  :values="nbProjectAvailables"
                  :label="$t('trainingsession.fields.multiproject.nbProject')"
                  :rules="internalValue.active ? $options.rules.nbProject : []"
                  :disabled="!internalValue.active"
                  v-bind="attrs"
                  v-on="on"
                  @input="change"
                />
              </template>
              <span v-text="$t('trainingsession.fields.multiproject.nbProjectWarning')" />
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row no-gutters class="px-5">
          <v-col class="px-5">
            <v-autocomplete
              v-model="internalValue.standardDrawId"
              :items="multiProjectStandardDrawList"
              :label="$t('trainingsession.fields.multiproject.standardDrawId')"
              :rules="internalValue.active ? $options.rules.standardDrawId : []"
              :disabled="!internalValue.active"
              item-text="name"
              item-value="id"
              @input="changeStandardDrawId"
            />
          </v-col>
          <v-col class="px-5">
            <v-autocomplete
              v-model="internalValue.ccpmDrawId"
              :items="multiProjectCcpmDrawList"
              :label="$t('trainingsession.fields.multiproject.ccpmDrawId')"
              :rules="internalValue.active ? $options.rules.ccpmDrawId : []"
              :disabled="!internalValue.active"
              item-text="name"
              item-value="id"
              @input="change"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import AgNumberSelect from 'src/components/common/AgNumberSelect'
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'

export default {
  name: 'MultiprojectSessionForm',
  components: {
    AgNumberSelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    multiProjectVersionList: {
      type: Array,
      required: true,
    },
    multiProjectDrawList: {
      type: Array,
      required: true,
    },
    nbProjectAvailables: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    internalValue: null,
  }),
  computed: {
    multiProjectStandardDrawList () {
      return this.multiProjectDrawList.filter(draw => draw.type === 'standard')
    },
    multiProjectCcpmDrawList () {
      return this.multiProjectDrawList.filter(draw => draw.type === 'ccpm')
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        this.internalValue = Helpers.clone(this.value)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
    },
    changeStandardDrawId () {
      const standardDraw = this.multiProjectStandardDrawList
        .find(draw => draw.id === this.internalValue.standardDrawId)

      if (standardDraw?.relatedDraw) {
        this.internalValue.ccpmDrawId = standardDraw.relatedDraw
      }
      else if (standardDraw) {
        this.internalValue.ccpmDrawId = ''
      }
    },
  },
  rules: {
    versionId: [
      FormRules.required('error.form.required'),
    ],
    nbProject: [
      FormRules.required('error.form.required'),
      FormRules.greater('error.form.required', { number: 0 }),
    ],
    standardDrawId: [
      FormRules.required('error.form.required'),
    ],
    ccpmDrawId: [
      FormRules.required('error.form.required'),
    ],
  },
}
</script>
